import http from "@/shared/services/http";
import {CustomerParams} from "@/modules/customers/params";

export const createCustomer = (data: any) => http.post(`v1/customers`, data);
export const listCustomer = (params?: CustomerParams) => http.get(`v1/customers`, { params });
export const singleCustomer = (id: string) => http.get(`v1/customers/${id}`);
export const updateCustomer = (id: string, data: any) => http.put(`v1/customers/${id}`, data);
export const deleteCustomer = (id: string) => http.delete(`v1/customers/${id}`);
export const createCustomerGuest = (data: any) => http.post(`v1/customers/guest`, data);